<div class="service-popup-container">
  <!-- Top Section: Program Menu Bar with Dropdowns and System Status -->
  <div class="popup-row top-row program-menu-bar"
    [ngClass]="{ 'online-icon': systemOnline, 'offline': !systemOnline && !systemStateUnknown, 'unknown': systemStateUnknown }">

    <span class="popup-title" *ngIf="system$ | async as system">{{ system.number }} - {{ system.name }}</span>

    <span class="system-status-label ">
      Status:
      <span *ngIf="systemStateUnknown">Unknown</span>
      <span *ngIf="!systemStateUnknown && systemOnline" class="online">Online</span>
      <span *ngIf="!systemStateUnknown && !systemOnline" class="offline">Offline</span>
    </span>
    <button mat-button *ngIf="network$ | async as network" [matMenuTriggerFor]="networkMenu" aria-label="Network signal"
      class="topbar-signal-btn" style="display: flex; align-items: center; min-width: 0;">
      <mat-icon style="color:white"
        [ngClass]="{ 'network-usable': network.signalQuality === 'Usable', 'network-poor': network.signalQuality === 'Poor' || network.signalQuality === 'Error' }">wifi</mat-icon>
      <span style="margin-left: 3px; font-size: 16px;color:white" *ngIf="network.asu">{{network.asu}} asu</span>
      <span style="margin-left: 3px; font-size: 16px;color:white" *ngIf="!network.asu">NA</span>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="topBarMenu" aria-label="More actions" class="topbar-more-btn">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #networkMenu="matMenu">
      <div style="padding: 16px; max-width: 220px;">
        <div style="font-weight: bold; margin-bottom: 8px;">Network Signal</div>
        <div *ngIf="network$ | async as network">
          <div>Signal: {{ network.asu }}asu</div>
          <div>Signal Quality: {{ network.signalQuality }}</div>
          <div>Band: {{ network.band }}</div>
          <div>Operator: {{ network.operator }}</div>
          <div>{{ lastNetworkStatusUpdate }}</div>
        </div>
        <hr />
        <div style="font-weight: bold; margin-bottom: 8px;">SIM</div>
        <span>ICCID:</span>
        <div *ngIf="sim$ | async as sim" style="display: flex; align-items: center; gap: 6px;">
          <span>{{ sim.modem.iccid }}</span>
          <button mat-icon-button
            style="font-size: 16px; width: 28px; height: 28px; min-width: 28px; min-height: 28px; padding: 0;"
            (click)="copyToClipboard(sim.modem.iccid)">
            <mat-icon style="font-size: 18px;">file_copy</mat-icon>
          </button>
        </div>
        <hr />
        <div style="font-weight: bold; margin-bottom: 8px;">Modem</div>
        <ng-container *ngIf="modem$ | async as modem">
          <span>Serial number:</span>
          <div style="display: flex; align-items: center; gap: 6px;">
            <span>{{ modem.firmware.sn }}</span>
            <button mat-icon-button
              style="font-size: 16px; width: 28px; height: 28px; min-width: 28px; min-height: 28px; padding: 0;"
              (click)="copyToClipboard(modem.firmware.sn)">
              <mat-icon style="font-size: 18px;">file_copy</mat-icon>
            </button>
          </div>
          <div>Firmware:</div>
          <div>{{ modem.firmware.firmware_ver }}</div>
          <div>Model:</div>
          <div>{{ modem.firmware.model }}</div>
        </ng-container>
      </div>
      <button mat-menu-item [matMenuTriggerFor]="networkMoreMenu" (click)="$event.stopPropagation()">
        <mat-icon>add</mat-icon>
        <span>More</span>
      </button>
      <hr />
      <button mat-menu-item (click)="networkStatus()">
        <mat-icon>wifi</mat-icon>
        <span>Connection information</span>
      </button>
      <button mat-menu-item (click)="startNetworkTestingLoop()">
        <mat-icon>autorenew</mat-icon>
        <span>Start network testing for 5min</span>
      </button>
      <button mat-menu-item (click)="stopNetworkTestingLoop()">
        <mat-icon>stop</mat-icon>
        <span>Stop network testing</span>
      </button>
    </mat-menu>

    <mat-menu #networkMoreMenu="matMenu">
      <div style="padding: 16px; max-width: 220px;">
        <div *ngIf="network$ | async as network">
          <div style="font-weight: bold; margin-bottom: 8px;">More network information</div>
          <div>Signal: {{ network.asu }}asu</div>
          <div>Signal Quality: {{ network.signalQuality }}</div>
          <div>Band: {{ network.band }}</div>
          <div>Operator: {{ network.operator }}</div>
          <div>{{ lastNetworkStatusUpdate }}</div>
          <div>Mode: {{ network.mode }}</div>
          <div>Submode: {{ network.submode }}</div>
          <div>MCC: {{ network.mcc }}</div>
          <div>MNC: {{ network.mnc }}</div>
          <div>Cell ID: {{ network.cellid }}</div>
          <div>PCI: {{ network.pci }}</div>
          <div>EARFCN: {{ network.earfcn }}</div>
          <div>Freq band ind: {{ network.freq_band_ind }}</div>
          <div>UL bandwidth: {{ network.ul_bandwidth }}</div>
          <div>DL bandwidth: {{ network.dl_bandwidth }}</div>
          <div>TAC: {{ network.tac }}</div>
          <div>RSRP: {{ network.rsrp }}</div>
          <div>RSRQ: {{ network.rsrq }}</div>
          <div>RSSI: {{ network.rssi }}</div>
          <div>SINR: {{ network.sinr }}</div>
          <div>CQI: {{ network.cqi }}</div>
          <div>UL Bandwidth: {{ network.ulBandwidth }}</div>
          <div>DL Bandwidth: {{ network.dlBandwidth }}</div>
          <hr />
          <button mat-icon-button (click)="copyToClipboard(network)"><mat-icon>file_copy</mat-icon></button>
        </div>
      </div>
    </mat-menu>

    <mat-menu #topBarMenu="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="jsdMenu" (click)="$event.stopPropagation()">
        <mat-icon>computer</mat-icon>
        <span>JSD</span>
      </button>
      <button mat-menu-item [matMenuTriggerFor]="modemMenu" (click)="$event.stopPropagation()">
        <mat-icon>router</mat-icon>
        <span>Modem</span>
      </button>
      <button mat-menu-item (click)="checkAllChannelStatus();">
        <mat-icon>grid_on</mat-icon>
        <span>Check all channels</span>
      </button>
      <button mat-menu-item (click)="requestQueUpdate();">
        <mat-icon>list</mat-icon>
        <span>Que Status</span>
      </button>
      <ng-container *ngIf="system$ | async as system">
        <button mat-menu-item *ngIf="machines && machines.length"
          (click)="openSystemInNewWindow(system.siteId, system.systemId, machines[0].machineId); $event.stopPropagation()">
          <mat-icon>link</mat-icon>
          <span>System page</span>
        </button>
      </ng-container>

    </mat-menu>
    <mat-menu #jsdMenu="matMenu">
      <button mat-menu-item (click)="requestElimination()">
        <mat-icon>playlist_remove</mat-icon>
        <span>Request elimination</span>
      </button>
      <button mat-menu-item (click)="resetJSD()">
        <mat-icon>replay</mat-icon>
        <span>Reset JSD</span>
      </button>
      <hr />
      <button mat-menu-item (click)="requestJSDVersion()">
        <mat-icon>receipt_long</mat-icon>
        <span>Request version</span>
      </button>
      <button mat-menu-item (click)="readJSDLog()">
        <mat-icon>list_alt</mat-icon>
        <span>Read log</span>
      </button>
    </mat-menu>
    <mat-menu #modemMenu="matMenu">
      <button mat-menu-item (click)="networkStatus()">
        <mat-icon>wifi</mat-icon>
        <span>Connection information</span>
      </button>
      <button mat-menu-item (click)="startNetworkTestingLoop()">
        <mat-icon>autorenew</mat-icon>
        <span>Start network testing for 5min</span>
      </button>
      <button mat-menu-item (click)="stopNetworkTestingLoop()">
        <mat-icon>stop</mat-icon>
        <span>Stop network testing</span>
      </button>
    </mat-menu>
  </div>

  <div class="popup-row middle-row">
    <div class="machines-row cards-row">
      <ng-container *ngIf="machines && machines.length; else noMachines">
        <div class="machine-card" *ngFor="let machine of machines">
          <mat-card>
            <ng-container *ngIf="machine.dataStale">
              <div class="stale-overlay"></div>
            </ng-container>
            <ng-container *ngIf="machine.isStale">
              <div class="stale-overlay">
                <div class="stale-text">
                  <b>Data outdated:</b><br /> Last received update <br>{{ machine.lastestUpdate }}<br />({{
                  machine.fromNow }})
                </div>
              </div>
            </ng-container>
            <mat-card-header>
              <div mat-card-avatar class="machine-avatar">
                <mat-icon
                  [ngClass]="{ 'online-icon': machine.state != 'fault' && machine.dispState != 'fault' && !machine.dataStale, 'offline': machine.state == 'fault' || machine.dispState == 'fault' }">
                  {{ machine.state == 'fault' || machine.dispState == 'fault' ? 'cancel' : 'check_circle' }}
                </mat-icon>
              </div>
              <mat-card-title>Node {{ machine.name }}</mat-card-title>
              <mat-card-subtitle>{{ machine.model }}</mat-card-subtitle>

              <button class="machine-menu-button" mat-icon-button [matMenuTriggerFor]="machineMenu"
                (click)="selectedMachine = machine; $event.stopPropagation()" aria-label="Machine menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #machineMenu="matMenu">
                <button mat-menu-item (click)="resetMachine(machine.index, machine.name);">
                  <mat-icon>outbox</mat-icon>
                  <span>Reset machine</span>
                </button>
                <button mat-menu-item (click)="collectProductElevetor(machine.index, machine.name);">
                  <mat-icon>lock_open</mat-icon>
                  <span>Open hatch</span>
                </button>
                <button mat-menu-item (click)="resetSoldOut(machine.index, machine.name);">
                  <mat-icon>autorenew</mat-icon>
                  <span>Reset sold out</span>
                </button>
                <button mat-menu-item [matMenuTriggerFor]="lightsMenu" (click)="$event.stopPropagation()">
                  <mat-icon>lightbulb</mat-icon>
                  <span>Lights</span>
                </button>
                <hr />

                <button mat-menu-item (click)="updateStatus();">
                  <mat-icon>change_circle</mat-icon>
                  <span>Update status</span>
                </button>
                <button mat-menu-item (click)="updateMachineIdentification(machine.index);">
                  <mat-icon>fingerprint</mat-icon>
                  <span>Update identification</span>
                </button>
                <button mat-menu-item (click)="updateTemperature();">
                  <mat-icon>thermostat</mat-icon>
                  <span>Check temperature</span>
                </button>
                <hr />

                <button mat-menu-item (click)="checkChannel(machine.index, machine.name); $event.stopPropagation()">
                  <mat-icon>start</mat-icon>
                  <span>Read channel status</span>
                </button>
                <button mat-menu-item [matMenuTriggerFor]="faultsMenu" (click)="$event.stopPropagation()">
                  <mat-icon>warning</mat-icon>
                  <span>Faults</span>
                </button>
              </mat-menu>

              <mat-menu #lightsMenu="matMenu">
                <button mat-menu-item
                  (click)="setLightState(machine.index, machine.name, true); $event.stopPropagation()">
                  <mat-icon style="color: #fbc02d;">lightbulb</mat-icon>
                  <span>Turn On</span>
                </button>
                <button mat-menu-item
                  (click)="setLightState(machine.index, machine.name, false); $event.stopPropagation()">
                  <mat-icon>lightbulb_outline</mat-icon>
                  <span>Turn Off</span>
                </button>
              </mat-menu>


              <mat-menu #faultsMenu="matMenu">
                <button mat-menu-item (click)="readActiveFaults(machine.index, machine.name); $event.stopPropagation()">
                  <mat-icon style="color: #830e0e;">warning</mat-icon>
                  <span>Read active</span>
                </button>
                <button mat-menu-item
                  (click)="readInactiveFaults(machine.index, machine.name); $event.stopPropagation()">
                  <mat-icon>warning_off</mat-icon>
                  <span>Read inactive</span>
                </button>
              </mat-menu>
            </mat-card-header>
            <mat-card-content>
              <p><span class="subtitle">Status:</span><br />
                <span
                  [ngClass]="{ 'online': machine.state == 'ready', 'offline': machine.state == 'fault', 'busy': machine.state == 'busy' }">
                  {{ machine.statusMessage }}
                </span>
              </p>
              <p> <span class="subtitle">Dispense Status: </span><br />
                <span
                  [ngClass]="{ 'online': machine.dispState == 'ready', 'offline': machine.dispState == 'fault', 'busy': machine.dispState == 'busy' }">
                  {{ machine.dispStatusMessage }}
                </span>
              </p>
              <p *ngIf="machine.fault"> Fault: <br /><span class="offline">
                  {{ machine.faultMessage }}
                </span></p>
            </mat-card-content>
            <mat-card-footer class="machine-status-bar">
              <div class="status-item">
                <mat-icon class="status-icon" [style.color]="machine.light === 'Light On' ? '#fbc02d' : null"
                  [matTooltip]="machine.light">
                  {{ machine.light === 'Light On' ? 'lightbulb' : 'lightbulb_outline' }}
                </mat-icon>
              </div>
              <div class="status-item">
                <mat-icon class="status-icon" [style.color]="machine.door === 'Door closed.' ? '#388e3c' : '#fbc02d'"
                  [matTooltip]="machine.door">
                  {{ machine.door === 'Door closed.' ? 'sensor_door' : 'meeting_room' }}
                </mat-icon>
              </div>
              <div class="temperature-indicator"
                [ngClass]="{'cold': machine.temperature < 5, 'hot': machine.temperature > 5}">
                {{machine.temperature}}°C
              </div>

            </mat-card-footer>
          </mat-card>
        </div>
      </ng-container>

      <ng-template #noMachines>
        <div class="no-machines">No machines available.</div>
      </ng-template>

    </div>
  </div>

  <div class="popup-row bottom-row">
    <mat-tab-group><mat-tab label="Terminal">
        <app-shell *ngIf="isTerminalAdmin !== null && systemNumber" [id]="systemId" [systemIP]="systemIP"
          [version]="version" [releaseDate]="releaseDate" [jsdVersion]="jsdVersion" [terminalAdmin]="isTerminalAdmin"
          [systemNumber]="systemNumber"></app-shell>
      </mat-tab>

      <mat-tab label="Statistics">
        <div class="tab-content">
          <app-authenticated-iframe-wrapper [src]="statisticsUrl" width="100%" height="1200px"
            frameborder="0"></app-authenticated-iframe-wrapper>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div class="footer-row"> MQTT{{ serverUsed }}, {{ mqttClientId }}</div>
  </div>
</div>